/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_Adjust_CloseInputs */

const en_us2_workout_quick_adjust_close = /** @type {(inputs: Workout_Quick_Adjust_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done`)
};

const pt_br2_workout_quick_adjust_close = /** @type {(inputs: Workout_Quick_Adjust_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronto`)
};

const es_419_workout_quick_adjust_close = /** @type {(inputs: Workout_Quick_Adjust_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listo`)
};

const pt_pt2_workout_quick_adjust_close = /** @type {(inputs: Workout_Quick_Adjust_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concluído`)
};

const fr_fr2_workout_quick_adjust_close = /** @type {(inputs: Workout_Quick_Adjust_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const de_de2_workout_quick_adjust_close = /** @type {(inputs: Workout_Quick_Adjust_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fertig`)
};

const it_it2_workout_quick_adjust_close = /** @type {(inputs: Workout_Quick_Adjust_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fatto`)
};

/**
* | output |
* | --- |
* | "Done" |
*
* @param {Workout_Quick_Adjust_CloseInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_adjust_close = /** @type {((inputs?: Workout_Quick_Adjust_CloseInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_Adjust_CloseInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_adjust_close(inputs)
	if (locale === "es-419") return es_419_workout_quick_adjust_close(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_adjust_close(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_adjust_close(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_adjust_close(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_adjust_close(inputs)
	return en_us2_workout_quick_adjust_close(inputs)
});
export { workout_quick_adjust_close as "workout-quick.adjust_close" }